import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=93966052&scoped=true&"
import script from "./TheButton.vue?vue&type=script&lang=js&"
export * from "./TheButton.vue?vue&type=script&lang=js&"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=93966052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93966052",
  null
  
)

export default component.exports